import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Mail, ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";

export default function BookingSuccess() {
  const { state } = useLocation();
  const reference = state?.reference;
  const email = state?.email;

  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Header />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24" data-testid="booking-success">
        <div className="rounded-3xl bg-white border border-slate-200 shadow-xl p-8 sm:p-12 text-center">
          <div className="mx-auto h-16 w-16 rounded-full bg-[#FFF3E6] border border-[#FFB870] flex items-center justify-center">
            <CheckCircle2 className="h-8 w-8 text-[#FF7F00]" />
          </div>
          <h1 className="mt-6 font-display text-3xl sm:text-4xl font-bold text-slate-900">Request received</h1>
          <p className="mt-3 text-slate-600 leading-relaxed">
            Thanks — we've saved your clearance request and sent a confirmation to {email ? <span className="font-semibold text-slate-800">{email}</span> : "your email"}.
            The team will be in touch shortly to confirm the slot.
          </p>

          {reference && (
            <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#FFF3E6] border border-[#FFB870] px-4 py-2 text-sm">
              <span className="text-slate-500">Reference</span>
              <span className="font-mono font-bold text-[#B85800]" data-testid="booking-reference">{reference}</span>
            </div>
          )}

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button asChild data-testid="success-cta-home" className="bg-[#FF7F00] hover:bg-[#E67000] text-white h-12 px-6 rounded-full font-semibold">
              <Link to="/">Back to home <ArrowRight className="ml-1 h-4 w-4" /></Link>
            </Button>
            <a
              href="mailto:waitesclearance@gmail.com"
              className="inline-flex items-center gap-2 h-12 px-5 rounded-full border border-slate-200 text-slate-700 hover:bg-slate-50 font-semibold"
              data-testid="success-cta-email"
            >
              <Mail className="h-4 w-4" /> Email us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
